import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Checkbox, Card, message, Col } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, EditOutlined } from "@ant-design/icons";
import App from "./LayoutMobile";
import axios from "axios";
import { Config } from "./Common/Config";

const ProfileForm = () => {
  const hasFetched = useRef(false);

  const [form] = Form.useForm();
  const [twoFactorAuth, settwoFactorAuth] = useState({
    isUserVerified: false,
    twoFactorCheckbox: false
  });

  const [userData, setuserData] = useState({});
  const [phone_number, setphone_number] = useState(null);
  const [optcode, setoptcode] = useState(null);
  const [showSMSCode, setshowSMSCode] = useState(false);
  const [loading, setloading] = useState(false);
  const [showVerifyButton, setshowVerifyButton] = useState(false);
  const [showVerify2FA, setshowshowVerify2FA] = useState(false);
  const [phoneNumberVerified, setphoneNumberVerified] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  useEffect(() => {
    if (!hasFetched.current) {
      getLoggedInUserData()
      hasFetched.current = true;
    }
  }, [])
  const getLoggedInUserData = async () => {
    try {
      const response = await axios.get(`${Config.urlLogin}/api/v1/profile`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response?.data?.data?.user) {
        setuserData(response.data.data.user)
        if (response?.data?.data?.user) {
          form.setFieldsValue({
            ...response.data.data.user,
            is_2fa_enabled: response?.data?.data?.user?.is_2fa_enabled == 1 ? true : false,
            verified: twoFactorAuth.isUserVerified ? true : false,
            // passwordNew: null,
            // password_confirmation: undefined,
          });
          setphone_number(response?.data?.data?.user.phone_number)
          setphoneNumberVerified(response?.data?.data?.user?.is_2fa_enabled)
          setshowVerifyButton(response?.data?.data?.user?.is_2fa_enabled)
          setshowshowVerify2FA(response?.data?.data?.user?.is_2fa_enabled)
        }
        hasFetched.current = false;
      }
    } catch (error) {
      console.log('error in get clinic data ::::', error)
    }
  }
  const onFinish = async (values) => {
    setloading(true);
    // if (values.is_2fa_enabled) {
    //   delete values.is_2fa_enabled
    // }
    // console.log(phoneNumberVerified,'onFinish:::', values)
    // return
      if (values.is_2fa_enabled && !phoneNumberVerified) {
        messageApi.error({
          type: 'error',
          content: 'Please verify your phone number first.',
        });
        setloading(false);
        return;
      }
      
    let payload = {}
    if (values?.name && values?.surname && values?.email) {
      payload = {
        ...payload,
        name: values?.name,
        surname: values?.surname,
        email: values?.email,
        password:   values?.passwordNew?.trim() ? values?.passwordNew?.trim() : undefined,
        password_confirmation: values?.password_confirmation?.trim() ? values?.password_confirmation?.trim() : undefined,
        phone_number: values?.phone_number,
        is_2fa_enabled: values.is_2fa_enabled ? 1 : 0,
      }
    }
    // return
    if (payload) {
      // console.log('::::::::update:::::', values)
      let url = `${Config.urlLogin}/api/v1/update-profile`

      // return
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log('response::::update', response)
      messageApi.success({
        type: 'succes',
        content: 'Profile updated successfully',
      });
    }

  }
  const sendOTP = async () => {
    if (!phone_number) {
      messageApi.error({
        type: 'error',
        content: 'Add phone number first',
      });
      return
    }
    try {


      let payload = {
        "phone_number": phone_number,//447920115473 //447832738093
        "type": "login via phone number"
      }
      // let url = `${Config.urlLogin}/api/v1/sms/otp/sent`
       let url = `${Config.logs_url}sms/otp/sent`
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      // console.log('response:::', response)
      if (response.data.status) {
        setshowSMSCode(true)
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      } else {
        setshowSMSCode(false)
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      }
    } catch (error) {
      setshowSMSCode(false)
      messageApi.error({
        type: 'error',
        content: error?.response?.data?.message || 'Error sending OTP',
      })
    }
  }
  const VerifyOTP = async () => {
    if (!phone_number) {
      messageApi.error({
        type: 'error',
        content: 'Add phone number first',
      });
      return
    }
    try {


      let payload = {
        "phone_number": phone_number,
        "otp": optcode
      }
      // console.log('payload :::',payload)
      let url = `${Config.logs_url}sms/auth/otp/verify`
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      // console.log('response:::', response)
      if (response.data.status) {
        setphoneNumberVerified(true)
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      } else {
        setphoneNumberVerified(false)
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      }
    } catch (error) {
      setphoneNumberVerified(false)
      messageApi.error({
        type: 'error',
        content: error?.response?.data?.message || 'Error sending OTP',
      })
    }
  }
  const editPhoneNumber = ()=>{
    setshowVerifyButton(!showVerifyButton)
  }
  // console.log('twoFactorAuth:::', twoFactorAuth)
  return (
    <App >
      {contextHolder}
      <Card style={{ maxWidth: 705, margin: "auto", padding: 24, borderRadius: 12, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
        <h3 style={{ marginBottom: 20,textAlign:'left' }}>Profile details</h3>

        <Form autoComplete={false}  form={form} layout="vertical" onFinish={onFinish}>
          {/* Name & Surname */}
          <div style={{ display: "flex", gap: "10px" }}>
            <Form.Item name="name" style={{ flex: 1 }} rules={[{ required: true, message: "Please enter your first name." }]}>
              <Input placeholder="First Name" />
            </Form.Item>

            <Form.Item name="surname" style={{ flex: 1 }} rules={[{ required: true, message: "Please enter your last name." }]}>
              <Input placeholder="Last name" />
            </Form.Item>
          </div>

          {/* Email */}
          <Form.Item name="email" rules={[{ type: "email", message: "Enter a valid email" }]}>
            <Input placeholder="Email" disabled />
          </Form.Item>

          {/* Password Field with Visibility Toggle */}
          <div style={{ display: "flex", gap: "10px" }}>
            <Form.Item name="passwordNew" style={{ width: '100%' }} rules={[{ required: false, message: "Please enter your password." }]}>
              <Input.Password
                name="passwordNew"
                autoComplete="passwordnew_Newsads"
                placeholder="Set New Password"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>
            <Form.Item name="password_confirmation" dependencies={['passwordNew']} style={{ width: '100%' }} rules={[({ getFieldValue }) => ({
              required: !!getFieldValue('passwordNew'), // Only required if password is entered
              message: 'Please confirm your password.',
            }), ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('passwordNew') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match!"));
              },
            })]} >
              <Input.Password
                placeholder="Confirm New Password"
                autoComplete="password_confirmationNew"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>
          </div>

          {/* Mobile Number & 2FA */}
          <div style={{ display: 'flex',gap:'10px', textAlign: "left" }}>
            <Form.Item name="phone_number"  style={{ flex: 1,width: '50%' }} rules={[{
              pattern: /^[0-9]+$/,
              message: "Only numeric values are allowed!",
            },]}>
              <Input placeholder="Add Mobile Number" disabled={showVerifyButton ? true : false} onChange={(e) => setphone_number(e.target.value)}  suffix={ <EditOutlined style={{ color: '#008385' }} onClick={()=>editPhoneNumber()} />}/>
            </Form.Item>
            <Form.Item name="is_2fa_enabled" valuePropName="checked" style={{ flex: 1,width: '50%' }} rules={[({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue('phone_number')) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Enter Number First!"));
              },
            })]}>
              <Checkbox checked  onChange={(e) => {
                if (!form.getFieldValue('phone_number')) {
                  e.preventDefault(); // prevent checking if phone is missing disabled={userData.is_2fa_enabled ? true : false}
                  return;
                }
                if (e.target.checked) {
                  //  console.log('::::::if',e.target.checked)
                  setshowshowVerify2FA(e.target.checked)
                } else {
                  // console.log('::::::else',e.target.checked)
                  setshowshowVerify2FA(e.target.checked)
                }
              }}>Two-factor Authentication</Checkbox>
            </Form.Item>

          </div>
          <div style={{ display: "flex", flexWrap: 'wrap', gap: "10px" }}>
            {(showSMSCode && showVerify2FA ) && <din style={{ flex: 1 }}>
              <Form.Item name="verified" valuePropName="checked" >
                <Input placeholder="Code"  onChange={(e)=>setoptcode(e.target.value)}/>
              </Form.Item>
              {/* ? <Form.Item name="verified" valuePropName="checked" >
              <Checkbox disabled >{twoFactorAuth.isUserVerified ? 'Number verified' : 'Number not verified'}</Checkbox> !showVerifyButton &&
            </Form.Item> : */}
            </din>}
            {(showSMSCode && showVerify2FA) ? <din style={{ flex: 1 }}>
              <Form.Item  >
                <Button block onClick={VerifyOTP} style={{ backgroundColor: "#008385", borderColor: "#008385", color: '#fff' }}>
                  {'Verify'}
                </Button>
              </Form.Item>
            </din> : ( showVerify2FA) && <Button block onClick={sendOTP} style={{ backgroundColor: "#008385", borderColor: "#008385", color: '#fff', marginBottom: 10 }}>
              Send OTP
            </Button>}

          </div>

          {/* Apply Button */}
          <Form.Item>
            <Button className="global-btns" type="primary" htmlType="submit" block style={{ backgroundColor: "#008385", borderColor: "#008385" }}>
              Apply
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </App>
  );
};

export default ProfileForm;
